import { Table } from "@/widgets/Table";
import type { MappedProduct } from "../types";
import styles from "../Dashboard.module.scss";
import { HEADERS } from "../constants/metrics";
import { DataRow } from "./Common/DataRow";

interface Props {
  products: MappedProduct[];
}

export function ArticleView({ products }: Props) {
  return (
    <Table columns={HEADERS} emptyMessage="Данные по товарам отсутствуют">
      {products.map((product, index) => (
        <div key={product.id} className={styles.tableRow}>
          <div className={styles.productCell}>
            <div className={styles.productNameWrap}>
              <div className={styles.productName}>
                <span className={styles.numberBadge}>{index + 1}</span>
                <span>{product.name}</span>
              </div>
            </div>{" "}
            <DataRow item={product} columns={HEADERS} />{" "}
          </div>{" "}
        </div>
      ))}{" "}
    </Table>
  );
}
